
import { createGame } from './Galactowr'

const node = document.getElementById('app');
createGame(node);



/** WEBPACK FOOTER **
 ** ./index.js
 **/